<template>
    <modal-cadu
        close
        :width="600"
        style="overflow: hidden;"
        v-model="valueData"
        :propStyle="borderStyle"
    >
        <div slot="all">
            <div slot="body">
                <div class="fontColor--text pa-6 pt-4">
                    <v-row no-gutters align="center" justify="center" class="error--text">
                        <v-col cols="auto">
                            <icon name="alert-triangle" :size="60"/>
                        </v-col>
                    </v-row>
                    <v-row no-gutters align="center" justify="center">
                        <v-col cols="auto" class="pl-4 headline">
                            {{titulo}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters align="center" justify="center" class="pt-2">
                      <v-col cols="auto">
                        {{getDescricao}}
                      </v-col>
                    </v-row>
                    <v-col cols="12" align="center" class="pt-4">
                        <div>
                            <button-cadu
                                text="OK"
                                @click="$emit('input', false)"
                                :backColor="$vuetify.theme.themes.light.error"
                            />
                        </div>
                    </v-col>
                </div>
            </div>
        </div>
    </modal-cadu>
</template>

<script>
import ModalMixin from '@/Mixins/ModalMixin'
export default {
  mixins: [ModalMixin],
  props: {
    titulo: {
      type: String,
      default: ''
    },
    descricao: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      borderStyle: {
        'border': '#ED1651 0px solid'
      }
    }
  },
  computed: {
    getDescricao () {
      return this.descricao.split('\n').filter(el => el !== '').join('')
    }
  }
}
</script>
